var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.isShowTips)?_c('p',[_vm._v("\n      Each documents will be available for re-download for 72 hours, just click \n      "),_c('span',{staticClass:"donwload-btn"},[_vm._v("Re-download")])]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }